module.exports = __webpack_public_path__ + "img/bg-solution.fe771171.png";